import React, { useEffect } from 'react';
import './HabitItPrivacy.css';

export default function HabitItPrivacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-content">
          <h1 className="privacy-title">Privacy Policy</h1>
          <div className="privacy-date">Effective Date: Feb 24, 2026</div>

          <div className="privacy-section">
            <p>
              Habeeb Sait built <strong>Habit Tracker</strong> as a habit tracking and digital wellbeing app. This Privacy Policy explains what information the app may process, how it is used, and the choices available to you.
            </p>
          </div>

          <div className="privacy-section">
            <h3>1. Information We Collect</h3>
            <p>Habit Tracker is designed to store most app data locally on your device. Depending on the features you use, the app may process:</p>
            <ul>
              <li>Habit data you create, such as habits, schedules, streaks, timers, reminders, and settings</li>
              <li>App blocking selections and usage-limit settings you choose on your device</li>
              <li>Subscription and purchase status, if you use premium features</li>
              <li>Device-level permissions, such as notifications, biometric authentication, widgets, or Family Controls / Screen Time access on iOS</li>
            </ul>
            <p>We do not require you to create an account to use the core app features unless that changes in a future version.</p>
          </div>

          <div className="privacy-section">
            <h3>2. How We Use Information</h3>
            <p>We use information processed by the app to:</p>
            <ul>
              <li>provide habit tracking, timers, reminders, widgets, and productivity features</li>
              <li>let you configure app blocking and digital wellbeing tools</li>
              <li>remember your preferences and settings</li>
              <li>verify premium entitlement status for subscriptions</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>3. Family Controls and Screen Time Data</h3>
            <p>On iOS, if you enable app blocking features, Habit Tracker may use Apple’s Family Controls, Device Activity, and Managed Settings frameworks.</p>
            <p>This access is used only to:</p>
            <ul>
              <li>allow you to select apps or categories to manage</li>
              <li>monitor usage against limits you set</li>
              <li>block selected apps when your configured limit is reached</li>
            </ul>
            <p>This information is used only for the functionality you explicitly enable. We do not use Family Controls access for advertising.</p>
          </div>

          <div className="privacy-section">
            <h3>4. Subscriptions</h3>
            <p>If you purchase a subscription, subscription management may be handled through Apple, Google, and RevenueCat. These providers may process information such as:</p>
            <ul>
              <li>purchase receipts</li>
              <li>subscription status</li>
              <li>device or app instance identifiers needed to validate purchases</li>
            </ul>
            <p>Their handling of data is governed by their own privacy policies:</p>
            <ul>
              <li>Apple: <a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener noreferrer">https://www.apple.com/legal/privacy/</a></li>
              <li>Google: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></li>
              <li>RevenueCat: <a href="https://www.revenuecat.com/privacy" target="_blank" rel="noopener noreferrer">https://www.revenuecat.com/privacy</a></li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>5. Data Storage</h3>
            <p>Most app data is stored locally on your device using local device storage. We do not sell your personal information.</p>
          </div>

          <div className="privacy-section">
            <h3>6. Permissions</h3>
            <p>Habit Tracker may request access to:</p>
            <ul>
              <li>Notifications, to send reminders and alerts</li>
              <li>Biometric authentication, to protect access to parts of the app on your device</li>
              <li>Widgets and app extensions, to show habit information on your home screen</li>
              <li>Family Controls / Screen Time on iOS, if you choose to enable app blocking features</li>
            </ul>
            <p>You can manage permissions at any time in your device settings.</p>
          </div>

          <div className="privacy-section">
            <h3>7. Data Sharing</h3>
            <p>We do not sell or rent your personal information. We may share limited information only with service providers necessary to operate app features, such as subscription infrastructure providers.</p>
          </div>

          <div className="privacy-section">
            <h3>8. Data Retention</h3>
            <p>Because most data is stored locally on your device, it remains there until you delete it, clear the app’s data, or uninstall the app, subject to how your device platform manages storage. Subscription-related records may be retained by Apple, Google, or RevenueCat according to their policies.</p>
          </div>

          <div className="privacy-section">
            <h3>9. Children’s Privacy</h3>
            <p>Habit Tracker is not intended to knowingly collect personal information from children through an online account system. If you believe personal information has been provided inappropriately, contact us and we will review the issue.</p>
          </div>

          <div className="privacy-section">
            <h3>10. Security</h3>
            <p>We take reasonable steps to minimize data collection and rely on platform security features where possible. However, no method of storage or transmission is completely secure.</p>
          </div>

          <div className="privacy-section">
            <h3>11. Changes to This Privacy Policy</h3>
            <p>We may update this Privacy Policy from time to time. If we make material changes, we will update the effective date above.</p>
          </div>

          <div className="privacy-section">
            <h3>12. Contact</h3>
            <div className="contact-info">
              <p>If you have questions about this Privacy Policy, contact:</p>
              <br />
              <strong>Habeeb Sait</strong><br />
              <a href="mailto:habeebdoesbusiness@gmail.com">habeebdoesbusiness@gmail.com</a>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
              <a href="/" style={{ color: 'var(--accent-bright)', textDecoration: 'none', fontWeight: 600, fontFamily: "'Inter', sans-serif" }}>← Back to Home</a>
          </div>
        </div>
      </div>
    </div>
  );
}
